exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-login_login_2UoMQ {\n    margin-right: 0.5625rem;\n  }\n  .user-login_avatar_1esDD {\n    margin-right: 0.5625rem;\n  }\n  ", ""]);

// exports
exports.locals = {
	"login": "user-login_login_2UoMQ",
	"avatar": "user-login_avatar_1esDD"
};